<style>
.v-text-field__details {
  margin: 0 !important;
}

.v-input__slot {
  margin: 0 !important;
}
</style>

<template>
  <v-container style="padding: 0;">
    <v-layout flat row>
      <v-flex flat style=" text-align:center">
        <v-card
          flat
          style=" margin:auto; max-width: 550px;   border-radius: 20px; background: #a3a6a2"
        >
          <v-card-text style="padding: 0;">
            <v-container style="padding: 10px;">
              <form @submit.prevent="onSignin">
                <v-text-field
                  name="email"
                  label="Email"
                  id="email"
                  v-model="email"
                  solo
                  type="email"
                  autocomplete="email"
                  required
                ></v-text-field>

                <v-text-field
                  name="password"
                  label="Password"
                  id="password"
                  solo
                  v-model="password"
                  type="password"
                  autocomplete="current-password"
                  required
                ></v-text-field>

                <v-btn
                  type="submit"
                  class="primary"
                  style="border-radius: 20px; color:white; text-transform: none; font-weight:600;"
                >
                  Sign In
                  <span slot="loader" class="custom-loader">
                    <v-icon light>cached</v-icon>
                  </span>
                </v-btn>
                <v-alert
                  color="red"
                  v-show="badLogin"
                  style="border-radius: 20px;"
                  >{{ errorUpdateMessage }}</v-alert
                >
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["user"]),
    nextRoute() {
      return "/news";
    },
  },
  data() {
    return {
      loading: false,
      email: "",
      password: "",
      auth: null,
      badLogin: false,
      errorUpdateMessage: ""
    };
  },
  watch: {
    user(auth) {
      if (auth) {
        this.$router.replace(this.nextRoute);
      }
    },
  },
  methods: {
    async onSignin() {
      try {
        const auth = await this.$auth.login(this.email, this.password);
        this.auth = auth;
        this.$store.dispatch("fetchUserData");
        this.badLogin = false

      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        this.badLogin = true
        this.errorUpdateMessage = "Sign In Error: " + error.message
      }
    },
    signUp() {
      this.$router.push("/signup");
    },
  },
};
</script>
